import styled, { css } from "styled-components";
import theme from "../../../Themes/light";
import { HtmlHTMLAttributes } from "react";

const { colors } = theme;

const commonStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .descricao-texto{
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 5rem 0;
    position: relative;
    width: 100%;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        height: 2px;
        border-radius: 100%;
        background-color: ${(props) => props.theme.colors.elements};
      }
  }

  .input-container{
    width: 100%;
    padding: 4rem 0;
  }
`;

const PagamentoCombinarContainer = styled.div<{
  configIn: "empresa" | "configuracoes" | "catalogo";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    (configIn === "configuracoes" || configIn === "catalogo") &&
    css`
      color: ${(props) => props.theme.colors.tertiary};
      .descricao {
        width: 100%;
        padding: 2rem 0 0 0;
        color: ${(props) => props.theme.colors.tertiary};
        text-align: left;
      }
    `}
`;

export { PagamentoCombinarContainer };
